import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { scheduleScrollPageToTop, unlockPageScroll, resetInnerScrollLocks } from "../helpers/scrollPageToTop.ts";

function isCommercialLivePath(pathname: string) {
  return pathname === "/commercialLive" || pathname.startsWith("/commercialLive/");
}

/** Put the page at the top on route changes. Query-string updates must not yank scroll. */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useLayoutEffect(() => {
    const prevPathname = prevPathnameRef.current;
    prevPathnameRef.current = pathname;

    unlockPageScroll(false);
    if (isCommercialLivePath(prevPathname) && !isCommercialLivePath(pathname)) {
      resetInnerScrollLocks();
    }

    const softLiveNav =
      isCommercialLivePath(prevPathname) && isCommercialLivePath(pathname);

    return scheduleScrollPageToTop(softLiveNav ? [] : [50]);
  }, [pathname]);

  return null;
}
